import contentStudioInstance from '@/utils/axiosContentStudio';

const onboardingUpdaters = {
  updateConsent: async (consent_version: string) => {
    const response = await contentStudioInstance.post(
      '/api/v1/onboarding/consent',
      {consent_version}
    );
    return response.data;
  },
};

export default onboardingUpdaters;
